import { MonthlyChecklistRepository } from "../../repositories/MonthlyChecklistRepository";
import { ChecklistItemEntity } from "../../entities/MonthlyChecklistEntity";

/**
 * Add Checklist Item Use Case
 */
export class AddChecklistItemUseCase {
  constructor(private repository: MonthlyChecklistRepository) {}

  async execute(
    checklistId: number,
    item: Omit<ChecklistItemEntity, "id" | "checklist_id" | "created_at" | "updated_at">
  ): Promise<ChecklistItemEntity> {
    return await this.repository.addChecklistItem(checklistId, item);
  }
}

